import React, { forwardRef } from 'react'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import withStyles from '@mui/styles/withStyles';
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Divider from '@mui/material/Divider'

const styles = theme => ({
    active: {
        '&.active': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.contrastText
        }
    },
    divider: {
        marginBottom: theme.spacing(1)
    }
})

const NavListGroup = props => {
    const {
        classes,
        items,
        header,
        icon,
        containerClass,
        buttonClass
    } = props
    return (
        <div className={containerClass || ''}>
            <ListItem>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={header} />
            </ListItem>
            <Divider variant="middle" className={classes.divider} />
            {items.map(item => (
                <ListItem
                    button
                    key={item.text}
                    className={classNames(classes.active, buttonClass || '')}
                    component={forwardRef((props, ref) => <div ref={ref}><NavLink {...props} /></div>)}
                    to={item.to}
                    disabled={item.disabled}
                >
                    {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                    <ListItemText primary={item.text} />
                </ListItem>
            ))}
        </div>
    )
}

export default withStyles(styles)(NavListGroup)
